import { ENDPOINT_BASE } from "../../api";
import { useQueryEntityById } from "../useEntityService";

// const INITIAL_CONFIG = {
//   appName: "Sample App",
//   projectName: "Sample Project",
//   selectedProject: "Sample Project",
//   defaultLanguage: "en",
//   appLogoSrc: "",
//   appLogoText: "Sample App Logo",
//   appFooterLogoSrc: "",
//   appFooterLogoText: "Footer Logo",
//   footerCentralImageSrc: "",
//   footerCentralImageText: "",
//   footerCentralImageContent: "",
//   hasCart: false,
//   hasMultiLanguage: false,
// };

export const DEFAULT_DB_KEY = 1;

export function useQueryAppConfiguration() {
  const apiConfig = {
    endpoint: `${ENDPOINT_BASE.APP_CONFIGURATION}/getAppConfigById`,
    queryKeyLabel: "appConfig",
    queryKeyId: DEFAULT_DB_KEY,
    retry: 2,
    enabledParam: DEFAULT_DB_KEY,
    staleTime: Infinity,
    cacheTime: Infinity,
    // initialData: INITIAL_CONFIG,
  };

  const { data, isLoading, isError } = useQueryEntityById({
    apiConfig,
  });

  return {
    data: data || {},
    isLoading,
    isError,
  };
}
